import ItemConnectionsList from '@app/components/ItemConnectionsList'
import SearchBar from '@app/components/SearchBar'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  actionCreators,
  IConnectionViewState,
} from '../modules/connectionView'

interface IConnectionViewRouterProps {
  id: string
}

interface IComponentState {
  filterText: string
}

type IComponentProps = IConnectionViewState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

class ConnectionConnections extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      filterText: '',
    }
  }

  public render() {
    return <div>{this._renderConnections()}</div>
  }

  private _renderConnections() {
    const filteredConnections = this.props.item.associated
      .filter((item: any) => {
        return this.state.filterText
          ? item.name
              .toLowerCase()
              .indexOf(this.state.filterText.toLowerCase()) > -1
          : true
      })
      .toList()

    return (
      <div>
        <SearchBar
          placeholder='Filter connections...'
          size='sm'
          value={this.state.filterText}
          onChange={(e) => {
            this.setState({
              filterText: e,
            })
          }}
        />
        <ItemConnectionsList
          className='mt-3'
          connections={filteredConnections}
        />
      </div>
    )
  }
}

export default withRouter(ConnectionConnections)
